import styled from "styled-components";
import { colors } from "src/styles";

export const SearchHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: nowrap;
  padding: 15px 0;
  border-bottom: 1px solid ${colors.grey.light12};
  margin-bottom: 20px;
`;

export const CreateButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
